<template lang="pug">
.brand-overview-stamp(v-if="data")
  //- nuxt-link.cover-links(:to="to" v-if="linked")
  .cover(v-image="data.main_image_url")
    .links
      .breadcrumbs
        nuxt-link.pf-nowrap(
          :to="{name: 'brands'}"
          :title="data.name") Brands /&nbsp;
        nuxt-link.pf-ellipsis(
          :to="to"
          :title="data.name") {{ data.name }}
      section.sharing(v-if="!linked")
        sharer(
          caption="Share"
          :show-caption="false"
          :show-facebook="false"
          :show-twitter="false")
      section.social-networks(v-if="socialLinks")
        social-tag(:social-networks="data.social_networks_attributes")

    .preview
      .flex
        .logo
          nuxt-link.contain(
            v-if="data.logo_url"
            v-image="data.logo_url.medium_url"
            :to="to"
            :title="data.name"
            v-click="() => $amplitude.trackBrand('BRAND_OVERVIEW_STAMP')")
        .information
          nuxt-link.name.pf-block.pf-ellipsis(:to="to" :title="data.name" v-tooltip="data.name" v-ellipsis) {{ data.name }}
          .address.pf-ellipsis(v-tooltip="$options.filters.brandAddress(data)" v-ellipsis) {{ data | brandAddress }}
        nuxt-link.link(
          v-if="linked"
          :to="to"
          :title="data.name"
          v-click="() => $amplitude.trackBrand('BRAND_OVERVIEW_STAMP')")
          span.hidden-sm-and-down View this brand
          i.bx.bx-right-arrow-alt

</template>

<script>
import Sharer from '~/components/Sharer'
import SocialTag from '~/components/tags/SocialTag.vue'

export default {
  components: { SocialTag, Sharer },

  props: {
    data: {
      type: Object,
      default: null
    },

    linked: {
      type: Boolean,
      default: false
    },

    socialLinks: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    to () {
      return this.data
        ? this.$links.brand(this.data)
        : { name: 'brands' }
    }
  }
}
</script>

<style lang="scss" scoped>
.brand-overview-stamp {
  position: relative;
  .cover-links {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1;
  }
  .cover {
    background: $--color-placeholder;
    background-position: center;
    background-repeat: no-repeat;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    border-radius: 0;
    overflow: hidden;
    background-size: cover;
    color: white;
    font-size: 12px;
    position: relative;
    padding: 16px;
    aspect-ratio: 8 / 3;
    @include media(md) {
      padding: 24px;
    }
    &:after {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background: rgba(#000, .35);
    }
    a {
      pointer-events: initial;
    }
    .links {
      display: flex;
      position: relative;
      z-index: 1;
      > *:not(:last-child) {
        margin-right: 2em;
      }
      .breadcrumbs {
        flex: 1 0;
      }
      .shareable-stamp {
        color: #fff;
      }
      .sharing {
        pointer-events: all;
      }
    }
    .preview {
      position: relative;
      z-index: 1;
      .flex {
        align-items: flex-end;
      }
      .logo {
        flex: 0 80px;
        margin-right: 1em;
        background-color: #fff;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: 50%;
        border-radius: 3px;
        @include media(sm) {
          flex-basis: 120px;
        }
        .contain {
          display: block;
          border-radius: $--radius;
          background-repeat: no-repeat;
          background-size: contain;
          background-position: center;
          width: 100%;
          height: 0;
          padding-top: 100%;
        }
      }
      .information {
        margin-bottom: .5em;
        flex: 1 0;
      }
      .name {
        font-weight: $--font-weight-bold;
        font-size: 1.5em;
      }
      .address {
        margin-top: .25em;
      }
      .link {
        display: flex;
        gap: .5em;
        background: white;
        color: $--color-text-regular;
        border-radius: 32px;
        align-items: center;
        font-size: 1rem;
        pointer-events: all;
        padding: 12px;
        @include media(md) {
          padding: 8px 12px 8px 16px;
        }
        &:hover {
          background: $--color-primary;
          color: white;
        }
        > * {
          min-width: 0;
          white-space: nowrap;
        }
        i {
          font-size: 20px;
        }
      }
      ::v-deep
      .search-box {
        .el-input-group__append {
          border: none;
          background-color: #F4F6F8;
        }
        input {
          border: none;
          background: #F4F6F8;
        }
      }
    }
  }
}
</style>
